import { History, HistoryTypes } from "@/modules/user/types/history";
import { apiWithAuth } from "../authApi";

export interface GetHistoryParams {
  offset?: number;
  limit?: number;
  type?: HistoryTypes;
}

export const getHistory = async ({
  type,
  offset,
  limit,
}: GetHistoryParams): Promise<History | undefined> => {
  try {
    const params = new URLSearchParams();

    if (offset !== undefined) params.append("offset", offset.toString());
    if (limit !== undefined) params.append("limit", limit.toString());
    if (type) params.append("type", type);

    const response = await apiWithAuth.get(
      `/user/history?${params.toString()}`
    );

    const answer = response.data as History;

    return answer;
  } catch (error) {
    return undefined;
  }
};
